function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Arrow - up");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Player/02---1820",
  transform: "translate(-203.000000, -16.000000)",
  fill: "#1E1F20"
}, React.createElement("g", {
  id: "Player/3"
}, React.createElement("g", {
  id: "Icons/Arrow---up",
  transform: "translate(210.500000, 21.000000) scale(1, -1) translate(-210.500000, -21.000000) translate(203.000000, 16.000000)"
}, React.createElement("g", {
  id: "Icons/Arrow---dropdown",
  transform: "translate(7.060800, 4.863520) scale(1, -1) translate(-7.060800, -4.863520) translate(0.060800, 0.363520)"
}, React.createElement("path", {
  d: "M6.96957686,8.36352 C6.71975803,8.36352 6.46997004,8.26311834 6.27950554,8.06273715 L0.285951252,1.75399298 C-0.0953170841,1.35267858 -0.0953170841,0.702016072 0.285951252,0.300864031 C0.667065342,-0.10028801 1.2851032,-0.10028801 1.66640238,0.300864031 L6.96957686,5.88318985 L12.2727822,0.30105886 C12.6540505,-0.100093182 13.2720267,-0.100093182 13.6531099,0.30105886 C14.0345634,0.702210901 14.0345634,1.35287341 13.6531099,1.75418781 L7.65964818,8.06293198 C7.46909114,8.26334564 7.21930315,8.36352 6.96957686,8.36352 Z",
  id: "Path",
  transform: "translate(6.969600, 4.181760) scale(1, -1) translate(-6.969600, -4.181760) "
}))))));

var SvgArrowup = function SvgArrowup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowup.d3ec7b38.svg";
export { ForwardRef as ReactComponent };